/**
 * Puntos cardinales compartidos (UF Front-only + ficha CAD / custom parcel).
 * Valores persistidos: N, NE, E, SE, S, SO, O, NO.
 */

/** Copy del vacío en selects / forms. Readouts compactos suelen usar "—". */
export const ORIENTATION_EMPTY_LABEL = 'Sin definir';

/** @type {{ value: string, label: string }[]} */
export const ORIENTATION_OPTIONS = [
  { value: 'N', label: 'Norte' },
  { value: 'NE', label: 'Noreste' },
  { value: 'E', label: 'Este' },
  { value: 'SE', label: 'Sureste' },
  { value: 'S', label: 'Sur' },
  { value: 'SO', label: 'Suroeste' },
  { value: 'O', label: 'Oeste' },
  { value: 'NO', label: 'Noroeste' },
];

const ORIENTATION_LABEL_BY_VALUE = Object.fromEntries(
  ORIENTATION_OPTIONS.map(({ value, label }) => [value, label]),
);

/**
 * Label de UI para un valor guardado. Desconocido → el propio valor; vacío → ''.
 * @param {unknown} value
 * @returns {string}
 */
export function getOrientationLabel(value) {
  if (value == null || value === '') return '';
  const key = String(value);
  return ORIENTATION_LABEL_BY_VALUE[key] || key;
}

/**
 * Label del Select cerrado / form: vacío → "Sin definir".
 * @param {unknown} value
 * @returns {string}
 */
export function getOrientationFormLabel(value) {
  if (value == null || value === '') return ORIENTATION_EMPTY_LABEL;
  return getOrientationLabel(value);
}

/**
 * Opciones del Select: catálogo fijo + valor actual si no está en la lista
 * (para no perder datos legacy / libres al editar).
 * @param {unknown} currentValue
 * @returns {{ value: string, label: string }[]}
 */
export function buildOrientationSelectOptions(currentValue) {
  const current = currentValue == null ? '' : String(currentValue);
  if (!current) return ORIENTATION_OPTIONS;
  const known = ORIENTATION_OPTIONS.some((option) => option.value === current);
  if (known) return ORIENTATION_OPTIONS;
  return [...ORIENTATION_OPTIONS, { value: current, label: current }];
}
